import * as React from 'react';

import { MoneySourceTabs } from './components/MoneySourceTabs';
import { useMoneySourceTabsContainer } from './hooks';

export const MoneySourceTabsContainer = () => {
  const { isRender, sources } = useMoneySourceTabsContainer();

  if (!isRender) {
    return null;
  }

  return <MoneySourceTabs sources={sources} />;
};
